"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _styles = _interopRequireDefault(require("../styles"));
var _Toolbar = _interopRequireDefault(require("@mui/material/Toolbar"));
var _Badge = _interopRequireDefault(require("../Badge/Badge"));
var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));
var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));
var _ChevronUp = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronUp"));
var _ChevronDown = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronDown"));
var _Edit = _interopRequireDefault(require("@ellucian/ds-icons/lib/Edit"));
var _ = require("../");
var _TableContext = require("./internal/TableContext");
var _EDSContext = require("../EDSContext/EDSContext");
var _tokens = require("../styles/tokens");
var _excluded = ["classes", "caption", "showExpandAllToggle", "showEditToggle", "children", "expanded", "onExpand", "onEdit", "location", "footerAlignItems", "showFooterToolbarOnEdit", "edsContext", "TypographyProps"];
var styles = function styles() {
  return {
    root: {
      display: 'flex',
      padding: _tokens.spacing40,
      '& svg': {
        height: _tokens.sizingSmall,
        width: _tokens.sizingSmall
      }
    },
    flex: {
      flexGrow: 1,
      color: _tokens.colorTextNeutral500
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: _tokens.widthFluid,
      alignItems: 'center'
    },
    footerLeft: {
      justifyContent: 'flex-start'
    },
    iconSize: {
      height: _tokens.sizingSmall,
      width: _tokens.sizingSmall
    },
    selectionBadge: {
      marginTop: '0.3rem',
      marginLeft: 0,
      marginRight: _tokens.spacing30
    },
    // all icons in the toolbar are resized to these dimensions
    userIconSize: {
      '& svg': {
        height: _tokens.sizingSmall,
        width: _tokens.sizingSmall
      }
    }
  };
};

/**
 * TableToolbar
 */
var TableToolbar = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classnames;
  var classes = props.classes,
    caption = props.caption,
    showExpandAllToggle = props.showExpandAllToggle,
    showEditToggle = props.showEditToggle,
    children = props.children,
    expanded = props.expanded,
    onExpand = props.onExpand,
    onEdit = props.onEdit,
    location = props.location,
    footerAlignItems = props.footerAlignItems,
    showFooterToolbarOnEdit = props.showFooterToolbarOnEdit,
    edsContext = props.edsContext,
    TypographyProps = props.TypographyProps,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var showToolbar = location === 'footer' && showFooterToolbarOnEdit || location === 'header';
  var toggleExpand = function toggleExpand(e) {
    if (e.type === 'keypress' && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onExpand(e);
    } else if (e.type === 'click') {
      onExpand(e);
    }
  };
  var toggleEdit = function toggleEdit(e) {
    if (e.type === 'keypress' && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onEdit(e);
    } else if (e.type === 'click') {
      onEdit(e);
    }
  };
  var expandLabel = expanded ? edsContext.formatMessage('component.Table.hideAll') : edsContext.formatMessage('component.Table.showAll');

  // if we're inside the table hierarchy, get the table context
  var context = (0, _TableContext.useTableContext)();
  var _ref = context ? context : {
      rowSelectionEnabled: false
    },
    rowSelectionEnabled = _ref.rowSelectionEnabled,
    selectedRowIds = _ref.selectedRowIds;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showToolbar && /*#__PURE__*/_react.default.createElement(_Toolbar.default, (0, _extends2.default)({
    className: classes.root
  }, rest, {
    ref: ref
  }), caption && /*#__PURE__*/_react.default.createElement(_.Typography, (0, _extends2.default)({
    variant: "h2",
    className: classes.flex
  }, TypographyProps), caption), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)((_classnames = {}, _classnames[classes.footer] = location === 'footer', _classnames[classes.footerLeft] = footerAlignItems === 'left', _classnames))
  }, rowSelectionEnabled && selectedRowIds.size > 0 && /*#__PURE__*/_react.default.createElement(_Badge.default, {
    classes: {
      badge: classes.selectionBadge
    },
    badgeContent: selectedRowIds.size
  }, /*#__PURE__*/_react.default.createElement(_.Typography, {
    variant: "srOnly"
  }, selectedRowIds.size === 1 ? edsContext.formatMessage('component.Table.selectionCountSingle') : edsContext.formatMessage('component.Table.selectionCount', {
    count: selectedRowIds.size
  }))), children, showEditToggle && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: edsContext.formatMessage('component.Table.edit')
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    color: "gray",
    "aria-expanded": expanded,
    "aria-label": edsContext.formatMessage('component.Table.edit'),
    onClick: function onClick(e) {
      return toggleEdit(e);
    },
    tabIndex: 0
  }, /*#__PURE__*/_react.default.createElement(_Edit.default, null))), showExpandAllToggle && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: expandLabel
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    color: "gray",
    "aria-expanded": expanded,
    "aria-label": expandLabel,
    onClick: function onClick(e) {
      return toggleExpand(e);
    },
    tabIndex: 0
  }, expanded ? /*#__PURE__*/_react.default.createElement(_ChevronUp.default, null) : /*#__PURE__*/_react.default.createElement(_ChevronDown.default, null))))));
});
TableToolbar.muiName = 'TableToolbar';
TableToolbar.displayName = 'TableToolbar';
TableToolbar.propTypes = {
  /**
   * The content of the table, normally `TableHeader` and `TableBody`.
   */
  children: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * Class name to be applied to the Alert container.
   */
  className: _propTypes.default.string,
  /**
   * Table caption or table title
   */
  caption: _propTypes.default.string,
  /**
   * Show expand all or collapse all icon for expansion panels on mobile or expandable rows.
   */
  showExpandAllToggle: _propTypes.default.bool,
  /**
   * Prop to toggle expand all.
   */
  expanded: _propTypes.default.bool,
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  /**
   * Callback to toggle the boolean value
   */
  onExpand: _propTypes.default.func,
  /**
   * Show editable toggle button to switch between edit and read-only table mode.
   */
  showEditToggle: _propTypes.default.bool,
  /**
   * Callback when edit toggle button is clicked
   */
  onEdit: _propTypes.default.func,
  /**
   * Align items for footer actions.
   */
  footerAlignItems: _propTypes.default.oneOf(['left', 'right']),
  /**
   * If you need to use actions along with table caption,
   * use `header` location. For action with footer, use `footer` location.
   * NOTE: Captions actions are always right aligned.
   * For footer actions, you can choose left or right.
   */
  location: _propTypes.default.oneOf(['header', 'footer']),
  /**
   * For footer, show the footer actions only when table is in edit mode.
   */
  showFooterToolbarOnEdit: _propTypes.default.bool,
  /**
   * Props that will be applied to the `Typography (caption)` element.
   */
  TypographyProps: _propTypes.default.object
};
TableToolbar.defaultProps = {
  showExpandAllToggle: false,
  showEditToggle: false,
  expanded: false,
  location: 'header',
  footerAlignItems: 'right'
};
var _default = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles)(TableToolbar));
exports.default = _default;